import { useTranslation } from 'react-i18next';

import { PayflowTopBar } from '@ctct/presentation-layer';

import type { PayflowTopBarWidgetProps } from './usePayflowTopBarWidget';
import { WithStatusHandling } from '../WithStatusHandling';

export const PayflowTopBarWidget = ({ status, data, handlers }: PayflowTopBarWidgetProps) => {
  const { t } = useTranslation();

  return (
    <WithStatusHandling
      skeletonHeight={64}
      status={status}
      errorMessage={status === 'error' ? data.message : undefined}
      retry={status === 'error' ? handlers?.retry : undefined}
    >
      {status === 'loaded' && data && handlers && (
        <PayflowTopBar
          onLogoClick={handlers.onLogoClick}
          onExitClick={handlers.onExitClick}
          nonInteractive={data.isNonInteractive()}
          isMWebVariantEnabled={data.isMWebVariantEnabled()}
          isDesktopExitHidden={data.isDesktopExitHidden()}
          closeLabel={t('common.close', { defaultValue: 'Close' })}
        />
      )}
    </WithStatusHandling>
  );
};
